import styled from "styled-components";

export const ContentWrapper = styled.div`
  word-break: normal;
`;
